import logger from '../utils/logger';

export class MagicLinkStore {
  private baseUrl: string;

  constructor() {
    this.baseUrl = import.meta.env.VITE_APP_BASE_SERVER_URL || 'http://localhost:3000';
  }

  public async requestMagicLink(email: string): Promise<{ message: string }> {
    const url = `${this.baseUrl}/auth/magic-link`;

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      return await response.json();
    } catch (error) {
      logger.error('Magic link request failed', {
        error: error instanceof Error ? error.message : String(error),
      });
      throw error;
    }
  }
}
